import { CustomSelect } from "#/components/atoms";
import { Button } from "@monta/design-system";
import { useAdditionalContext } from "../context/context";
import styles from "./styles.module.scss";

type Props = {
  moduleGroupFilters: { label: string; value: string }[];
};

const DesktopAdditionalReportFilter = (props: Props) => {
  const { setFilters, filters } = useAdditionalContext();
  const { moduleGroupFilters } = props;

  return (
    <div className={styles["filter-container"]}>
      <section className={styles["filter-desktop"]}>
        <div>فیلتر: </div>
        <div>
          <CustomSelect
            options={moduleGroupFilters}
            placeholder="گروه درسی"
            selectedOption={
              moduleGroupFilters.find(
                (item) => Number(item.value) == filters.selectedModuleGroup
              ) ?? null
            }
            onChange={(option) => {
              if (option) {
                setFilters({
                  ...filters,
                  selectedModuleGroup: Number(option.value)
                });
                return option;
              }
            }}
            tabIndex={0}
            disabled={false}
            containerClassName={styles["filter-desktop__filters-dropdown"]}
            bodyClassName={styles["filter-desktop__filters-dropdown__body"]}
          />
        </div>
      </section>
      <Button
        className={styles["filter-container__delete"]}
        width={98}
        borderRadius="2"
        disabled={!filters.selectedModuleGroup}
        height={44}
        onClick={() => {
          setFilters({});
        }}
      >
        حذف فیلترها
      </Button>
    </div>
  );
};

export default DesktopAdditionalReportFilter;
